import { createSlice } from "@reduxjs/toolkit";

export const businessSlice = createSlice({
  name: "business",
  initialState: {
    isLoading: false,
    isError: false,
    businessData: null,
    message: "",
    status_code: 0,
    getBusinessLoading: false,
    getBusinessError: false,
    getBusinessData: null,
    getBusinessMessage: "",
    getBusinessStatusCode: 0,
    getBusinessesTotal: undefined,
  },
  reducers: {
    onBusinessUpdate: (state) => {
      return {
        ...state,
        isLoading: true,
        isError: false,
        businessData: null,
        message: "",
        status_code: 0,
      };
    },
    onBusinessUpdateSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: false,
        businessData: data?.business,
        message,
        status_code,
      };
    },
    onBusinessUpdateError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: true,
        businessData: data?.business,
        message,
        status_code,
      };
    },
    onBusinessUpdateReset: (state) => {
      return {
        ...state,
        isLoading: false,
        isError: false,
        message: "",
        status_code: 0,
      };
    },
    onGetBusiness: (state) => {
      return {
        ...state,
        getBusinessLoading: true,
        getBusinessError: false,
        getBusinessData: null,
      };
    },
    onGetBusinessSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload;
      return {
        ...state,
        getBusinessLoading: false,
        getBusinessError: false,
        getBusinessData: data,
        getBusinessMessage: message,
        getBusinessStatusCode: status_code,
      };
    },
    onGetBusinessError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload;
      return {
        ...state,
        getBusinessLoading: false,
        getBusinessError: true,
        getBusinessData: data,
        getBusinessMessage: message,
        getBusinessStatusCode: status_code,
      };
    },
    onGetBusinessReset: (state) => {
      return {
        ...state,
        getBusinessLoading: false,
        getBusinessError: false,
        getBusinessData: null,
        getBusinessMessage: "",
        getBusinessStatusCode: 0,
      };
    },
    onGetBusinesses: (state, { payload }) => ({
      ...state,
      getBusinessesLoading: true,
      getBusinessesError: false,
      businessesList: payload?.append ? state.businessesList : null,
    }),
    onGetBusinessesSuccess: (state, { payload }) => {
      const { data = null, append = false, total } = payload;
      const nextList = data?.businesses ?? [];
      return {
        ...state,
        getBusinessesLoading: false,
        getBusinessesError: false,
        businessesList: append && Array.isArray(state.businessesList)
          ? [...state.businessesList, ...nextList]
          : nextList,
        getBusinessesTotal: total != null ? total : state.getBusinessesTotal,
      };
    },
    onGetBusinessesError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload;
      return {
        ...state,
        getBusinessesLoading: false,
        getBusinessesError: true,
        businessesList: data,
        getBusinessesMessage: message,
        getBusinessesStatusCode: status_code,
      };
    },
    onGetBusinessesReset: (state) => {
      return {
        ...state,
        getBusinessesLoading: false,
        getBusinessesError: false,
        businessesList: null,
        getBusinessesMessage: "",
        getBusinessesStatusCode: 0,
        getBusinessesTotal: undefined,
      };
    },
  },
});

export const {
  onBusinessUpdate,
  onBusinessUpdateSuccess,
  onBusinessUpdateError,
  onBusinessUpdateReset,
  onGetBusiness,
  onGetBusinessSuccess,
  onGetBusinessError,
  onGetBusinessReset,
  onGetBusinesses,
  onGetBusinessesSuccess,
  onGetBusinessesError,
  onGetBusinessesReset,
} = businessSlice.actions;

export default businessSlice.reducer;
